@if (isError) {
  <div class="h-[80%]">
    <app-something-went-wrong
      description="{{ 'cannotLoadMailAccount' | translate }}"
      [showPicture]="false"
      (retryEmitter)="retryData()"></app-something-went-wrong>
  </div>
}

@if (!isError) {
  <div class="flex-col-container-1">
    <div class="search-panel">
      <div class="button-group h-[40px]">
        <button
          mat-raised-button
          color="primary"
          class="page-block-button"
          aria-label="Add new contact"
          (click)="onCreateNewContact()">
          <mat-icon class="{{ useMobileView ? '!m-0' : '' }}">add</mat-icon>
          {{ useMobileView ? '' : ('newContact' | translate) }}
        </button>
        @if(canManageMailAccountContactsImportExport) {
          @if (isExporting) {
            <div class="w-[2.5rem]">
              <app-loader
                padding="0"
                [diameter]="'22'"
                height="100%"></app-loader>
            </div>
          } @else {
            <button
              mat-icon-button
              [attr.aria-label]="'exportExcel' | translate"
              (click)="exportExcel()"
              matTooltip="{{ 'exportExcel' | translate }}">
              <i class="far fa-file-excel fa-xs"></i>
            </button>
          }
          @if (isExportingVcCards) {
            <div class="w-[2.5rem]">
              <app-loader
                padding="0"
                [diameter]="'22'"
                height="100%"></app-loader>
            </div>
          } @else {
            <button
              mat-icon-button
              [attr.aria-label]="'exportVcCards' | translate"
              (click)="exportVcCards()"
              matTooltip="{{ 'exportVcCards' | translate }}">
              <span class="material-symbols-outlined"> file_save </span>
            </button>
          }
          <button
            mat-icon-button
            [attr.aria-label]="'uploadContacts' | translate"
            (click)="uploadContacts()"
            matTooltip="{{ 'uploadContacts' | translate }}">
            <span class="material-symbols-outlined"> upload </span>
          </button>
        }
        @if (selection.hasValue()) {
          <button
            mat-icon-button
            [attr.aria-label]="'sendEmailToContacts' | translate"
            matTooltip="{{ 'sendEmailToContacts' | translate }}"
            (click)="sendEmailToContacts(selection.selected)">
            <mat-icon>mail_outline</mat-icon>
          </button>
          <button
            mat-icon-button
            [attr.aria-label]="'label' | translate"
            matTooltip="{{ 'label' | translate }}"
            (click)="openTagsForContact()">
            <span class="material-symbols-outlined">label</span>
          </button>
          @if(canManageMailAccountContactsEditDelete) {
            <button
              mat-icon-button
              [attr.aria-label]="'delete' | translate"
              matTooltip="{{ 'delete' | translate }}"
              (click)="deleteContact()">
              <mat-icon>delete_outline</mat-icon>
            </button>
          }
        }
      </div>
      <div class="search-bar">
        <app-search-bar
          [fullWidth]="useMobileView"
          (searchEventEmitter)="onSearch()"
          (valueChangedEventEmitter)="onSearchValueChanged($event)"
          [search]="searchValue"></app-search-bar>
        <button mat-icon-button [matTooltip]="'filters' | translate" (click)="openFiltersTag()">
          <mat-icon class="icon" [class.blue]="!!filter?.tags?.length"
            >filter_list</mat-icon
          >
        </button>
        @if (!useMobileView) {
          <app-table-header
            [countTotal]="totalSize"
            (reloadEventEmitter)="reload()"
            [isReloadLoading]="isReloadLoading"></app-table-header>
        }
      </div>
    </div>
  </div>
}

@if (useMobileView && !isError && !isLoading) {
  <div class="buttons-mobile-container">
    <mat-checkbox
      color="primary"
      class="mb-2 mt-4"
      [checked]="selection.hasValue() && isAllSelected()"
      (change)="$event ? masterToggle() : null"
      [indeterminate]="selection.hasValue() && !isAllSelected()">
    </mat-checkbox>
    <app-table-header
      [countTotal]="totalSize"
      (reloadEventEmitter)="reload()"
      (searchOrderChangeEventEmitter)="searchOrderChange($event)"
      (changeOrderEventEmitter)="changeOrder()"
      [searchOrder]="searchOrder"
      [searchOrders]="searchOrders"
      [orderDirection]="filter.orderDirection"
      [isReloadLoading]="isReloadLoading"></app-table-header>
  </div>
  <div class="h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <div class="mobile-container-cards">
        @if (!isLoading) {
          @if (!!dataSource.data.length) {
            @for (contact of dataSource.data; track contact) {
              <div class="card">
                <div class="checkbox-col">
                  <mat-checkbox
                    color="primary"
                    class="mobile-card-title-checkbox"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(contact) : null"
                    [checked]="selection.isSelected(contact)">
                  </mat-checkbox>
                </div>
                <mat-card class="mobile-row">
                  <mat-card-content
                    (click)="onEditContactBtnClicked(contact)"
                    class="flex flex-1 cursor-default">
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'alias' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ contact.alias }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'designation' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ contact.companyName }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'name' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ contact.firstName }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'lastName' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ contact.lastName }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'mailAccount' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ contact?.defaultEmail ?? '' }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'label' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        <ng-container
                          *ngTemplateOutlet="
                            contactTags;
                            context: { contact }
                          "></ng-container>
                      </div>
                    </div>
                  </mat-card-content>
                  <div class="icons-mobile-block">
                    <ng-container
                      *ngTemplateOutlet="
                        actionButtons;
                        context: { contact }
                      "></ng-container>
                  </div>
                </mat-card>
              </div>
            }
          }
        }
      </div>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (!useMobileView && !isLoading && !isError) {
  <div class="settings-table-container h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              color="primary"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="
                selection.hasValue() && !isAllSelected()
              "></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="alias">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'alias' | translate }}
          </th>
          <td mat-cell *matCellDef="let contact">{{ contact.alias }}</td>
        </ng-container>
        <ng-container matColumnDef="designation">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'designation' | translate }}
          </th>
          <td mat-cell *matCellDef="let contact">{{ contact.companyName }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'name' | translate }}
          </th>
          <td mat-cell *matCellDef="let contact">{{ contact.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'lastName' | translate }}
          </th>
          <td mat-cell *matCellDef="let contact">
            {{ contact?.lastName ?? '' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="mailAccount">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'mailAccount' | translate }}
          </th>
          <td mat-cell *matCellDef="let contact">
            {{ contact?.defaultEmail ?? '' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef>{{ 'label' | translate }}</th>
          <td mat-cell *matCellDef="let contact">
            <ng-container
              *ngTemplateOutlet="
                contactTags;
                context: { contact }
              "></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
          <td mat-cell *matCellDef="let contact">
            <ng-container
              *ngTemplateOutlet="
                actionButtons;
                context: { contact }
              "></ng-container>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-default"></tr>
      </table>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (isLoading) {
  <div class="flex-1 overflow-hidden">
    <app-skeleton-table></app-skeleton-table>
  </div>
}

<ng-template #actionButtons let-contact="contact">
  <button
    mat-icon-button
    [attr.aria-label]="'sendEmailToContacts' | translate"
    matTooltip="{{ 'sendEmailToContacts' | translate }}"
    (click)="sendEmailToContacts([contact])">
    <mat-icon>mail_outline</mat-icon>
  </button>
  <button
    mat-icon-button
    [attr.aria-label]="'manageTags' | translate"
    matTooltip="{{ 'manageTags' | translate }}"
    (click)="openTagsForContact(contact); $event.stopPropagation()">
    <span class="material-symbols-outlined">label</span>
  </button>
  @if(canManageMailAccountContactsEditDelete) {
    <button
      mat-icon-button
      [attr.aria-label]="'edit' | translate"
      matTooltip="{{ 'edit' | translate }}"
      (click)="onEditContactBtnClicked(contact)">
      <mat-icon>edit_outline</mat-icon>
    </button>
  }
  @if(canManageMailAccountContactsEditDelete) {
    <button
      mat-icon-button
      [attr.aria-label]="'delete' | translate"
      matTooltip="{{ 'delete' | translate }}"
      (click)="deleteContact(contact)">
      <mat-icon>delete_outline</mat-icon>
    </button>
  }
</ng-template>

<ng-template #contactTags let-contact="contact">
  <div
    class="app-tags tags-main flex w-[90%] flex-wrap items-center gap-x-4 gap-y-1 py-1">
    @for (tag of contact.tags; track tag.tag) {
      <app-tag-component [tag]="tag" />
    }
  </div>
</ng-template>

<ng-template #addDrawer>
  @if (mailAccountId) {
    <app-contact-dialog
      [contactId]="editingContact"
      [mailAccountId]="mailAccountId"
      [useMobileView]="useMobileView"
      [loadTags]="loadTags"
      [insertTag]="insertTag"
      (sendEmailToContact)="sendEmailToContacts($event)"
      (submitEventEmitter)="onContactSubmit()"
      (unsavedStateChange)="contactFormDirty = $event" />
  }
</ng-template>

<ng-template #uploadContactsDrawer>
  <app-import-contacts
    [mailAccountId]="mailAccountId"
    (closeDrawer)="loadContactList(true)" />
</ng-template>

<ng-template #tagsDrawer>
  @if (!!mailAccountId && taggingContacts?.length) {
    <app-add-tags-dialog
      [initialTags]="tagsInitial"
      [loadTags]="loadTags"
      [insertTag]="insertTag"
      [saveTags]="saveTags"
      [isDrawer]="true"
      (closeEventEmitter)="taggingContacts = null"
      header="addLabels"
      label="newLabel" />
  }
</ng-template>

<ng-template #filterTagsDrawer>
  @if (!!mailAccountId && isOpenFilters) {
    <app-address-book-filter-drawer
      [mailAccountId]="mailAccountId"
      [initialTags]="filter.tags"
      (applyFilter)="searchWithFilter($event)" />
  }
</ng-template>
